import type { CardFormData, CardState } from '../types/entryRules.types';

export function sanitizeText(text: string): string {
  return text
    .replace(/<[^>]*>/g, '')
    .replace(/&(lt|gt|amp|quot|apos|#\d+|#x[\da-f]+);/gi, '')
    .replace(/javascript\s*:/gi, '')
    .replace(/data\s*:/gi, '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .trim();
}

export function isCardDirty(current: CardFormData, saved: CardFormData | null): boolean {
  if (saved === null) return true;
  return current.countryCode !== saved.countryCode || current.ruleText.trim() !== saved.ruleText.trim();
}

export function isCardComplete(data: CardFormData): boolean {
  return data.countryCode.trim().length > 0 && data.ruleText.trim().length > 0;
}

// Country codes already claimed by a card in the current list. A rule's country
// is also its Firestore document id, so two cards must never share one code.
export function getUsedCountryCodes(cards: CardState[]): Set<string> {
  const used = new Set<string>();
  for (const card of cards) {
    const code = card.currentData.countryCode.trim();
    if (code) used.add(code);
  }
  return used;
}
